import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, getBranches } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
class DocumentDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice: {},
            customer: {},
            branches: [],
            formData: {
                due_date: '',
                payment_status: '',
                vat_amount: '',
                total_amount: '',
                description: '',
                branch_id: ''
            },
            responseForm: {
                responseCode: '',
                responseExplanation: ''
            },
            invoice_content: '',
            modalOpen: false,
            responseModalOpen: false, // ✅ YENİ: Onay/Red modal
            isLoad: true,
            loading: false,
            responseSending: false, // ✅ YENİ: Yanıt gönderme loading
        }
    }
    async componentDidMount() {
        this.getInvoiceInfo();
        this.setState({
            branches: await getBranches(),
        })
    }
    getInvoiceInfo = async () => {
        const invoiceID = this.props.match.params.id;
        try {
            const response = await apiCall('business/ksoft/document-detail/' + invoiceID, 'get', null);
            this.setState({ invoice: response.invoice, customer: response.customer, isLoad: false });
            this.setState(prevState => ({
                formData: {
                    ...prevState.formData,
                    due_date: response.invoice.due_date,
                    payment_status: response.invoice.payment_status === "Ödendi" ? "paid" : "unpaid",
                    vat_amount: 0,
                    total_amount: response.invoice.invoice_total || 0,
                    description: response.invoice.description || '',
                    branch_id: response.invoice.branch_id || '',
                }
            }));

        } catch (e) {
            this.setState({ isLoad: false });
        }
    }


    handleInvoiceChange = (event) => {
        const { id, value } = event.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: value
            }
        }));
    };
    openCustomerDetail = (e) => {
        e.preventDefault();
        const link = `${process.env.PUBLIC_URL}/customer-detail/${this.state.invoice.customer_id}`
        window.open(link, "_blank");
    }
    showInvoice = async (e) => {
        e.preventDefault();
        window.open(`show-service-document/${this.state.invoice.id}`)
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const data = {
            due_date: this.state.formData.due_date,
            payment_status: this.state.formData.payment_status,
            amount: this.state.formData.total_amount,
            vat_amount: this.state.formData.vat_amount,
            description: this.state.formData.description,
            branch_id: this.state.formData.branch_id,
            customer_id: this.state.invoice.customer_id,
        }
        try {
            const response = await apiCall('business/ksoft/update-document/' + this.state.invoice.id, 'post', data);
            await this.getInvoiceInfo();
            mainHelper.toastMessage(response.status, response.message)
            this.setState({ loading: false });

        } catch (e) {
            this.setState({ loading: false });
        }

    }
    // ✅ YENİ: Modal aç/kapat
    openResponseModal = () => {
        this.setState({
            responseModalOpen: true,
            responseForm: { responseCode: '', responseExplanation: '' }
        });
    }

    closeResponseModal = () => {
        this.setState({ responseModalOpen: false });
    }

    // ✅ YENİ: Response form değişikliklerini handle et
    handleResponseChange = (event) => {
        const { id, value } = event.target;
        this.setState(prevState => ({
            responseForm: {
                ...prevState.responseForm,
                [id]: value
            }
        }));
    };

    // ✅ YENİ: Fatura yanıtını gönder (KABUL/RED)
    sendInvoiceResponse = async () => {
        const { responseCode, responseExplanation } = this.state.responseForm;

        // Validation
        if (!responseCode) {
            Swal.fire('Uyarı', 'Lütfen kabul veya red seçiniz!', 'warning');
            return;
        }

        this.setState({ responseSending: true });

        try {
            const data = {
                responseCode,
                responseExplanation: responseExplanation || null
            };

            const response = await apiCall(
                'business/ksoft/send-document-response/' + this.state.invoice.id,
                'post',
                data
            );

            this.setState({
                responseSending: false,
                responseModalOpen: false
            });

            if (response.status === 'success') {
                Swal.fire(
                    'Başarılı!',
                    response.message || 'Fatura yanıtı başarıyla gönderildi.',
                    'success'
                );

                // Fatura bilgilerini yenile
                await this.getInvoiceInfo();
            } else {
                Swal.fire(
                    'Hata!',
                    response.message || 'Yanıt gönderilemedi.',
                    'error'
                );
            }

        } catch (error) {
            this.setState({ responseSending: false });
            console.error('Response send error:', error);
            let errorMessage = 'Bir hata oluştu. Lütfen tekrar deneyiniz.';

            if (error.response && error.response.data) {
                // Laravel backend genelde bu 3’ünden biri olur:
                errorMessage = error.response.data.message
            } else if (error.message) {
                // Axios kendi mesajı
                errorMessage = error.message;
            }

            // Ekranda göster
            Swal.fire('Hata!', errorMessage, 'error');
        }
    }

    createReceivable = async () => {

        const result = await Swal.fire({
            title: 'Uyarı',
            text: "Mevcut toplam tutar üzerinden cari oluşturulacaktır.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, oluştur!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);
                const data = {
                    due_date: this.state.formData.due_date,
                    payment_status: this.state.formData.payment_status,
                    amount: this.state.formData.total_amount,
                    vat_amount: this.state.formData.vat_amount,
                    description: this.state.formData.description,
                    branch_id: this.state.formData.branch_id,
                    customer_id: this.state.invoice.customer_id,
                }
                if (!this.state.formData.total_amount || !this.state.formData.branch_id || !this.state.invoice.customer_id || !this.state.formData.due_date) {
                    Swal.fire(
                        'Uyarı!',
                        'Toplam tutar,şube,vade tarihi ve müşteri alanlarını kontrol ediniz!',
                        'warning'
                    );
                    return false;
                }
                try {
                    await apiCall('business/receivable/add-from-einbox/' + this.state.invoice.id, 'post', data);
                    await this.getInvoiceInfo();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Uyarı!',
                    'Cari başarıyla oluşturuldu.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Oluşturma işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    render() {
        const { invoice, customer, loading, branches } = this.state;
        const { userPermissions } = this.props;
        const userHasCreateInvoice = userPermissions.includes('invoice process');
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
                        <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="m-t-30">
                                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
                            </div>
                            <p>Yükleniyor</p>
                            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
                        </div>
                    </div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Fatura detayları"
                            Breadcrumb={[
                                { name: "Gelen Kutusu", navigate: "documents" },
                                { name: "Detay", navigate: "" },
                            ]}
                        />
                        <div className={this.state.modalOpen ? "modal fade show" : "modal fade"} role="dialog">
                            <div className="modal-dialog modal-lg" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="title" id="defaultModalLabel">
                                            Fatura Detayları
                                        </h4>
                                    </div>
                                    <div
                                        className="modal-body"
                                        style={{
                                            maxHeight: "90vh",
                                            overflow: "hidden",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <iframe
                                            srcDoc={this.state.invoice_content}
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                border: "none",
                                            }}
                                            title="Invoice Preview"
                                            onLoad={(e) => {
                                                const iframe = e.target;
                                                iframe.style.height = iframe.contentWindow.document.body.scrollHeight + "px";
                                            }}
                                        ></iframe>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            onClick={() => this.setState({ modalOpen: false })}
                                            className="btn btn-simple"
                                            data-dismiss="modal"
                                        >
                                            Kapat
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* ✅ YENİ: Onay/Red Modal */}
                        <div className={this.state.responseModalOpen ? "modal fade show" : "modal fade"}
                            style={{ display: this.state.responseModalOpen ? 'block' : 'none' }}
                            role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="title">
                                            <i className="fa fa-check-square-o"></i> Fatura Yanıtı Gönder
                                        </h4>
                                        <button
                                            type="button"
                                            className="close"
                                            onClick={this.closeResponseModal}
                                            disabled={this.state.responseSending}>
                                            <span>&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label htmlFor="responseCode" className="font-weight-bold text-cyan">
                                                Yanıt Tipi <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                id="responseCode"
                                                className="form-control"
                                                value={this.state.responseForm.responseCode}
                                                onChange={this.handleResponseChange}
                                                disabled={this.state.responseSending}>
                                                <option value="">Seçiniz...</option>
                                                <option value="KABUL">✓ KABUL</option>
                                                <option value="RED">✗ RED</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="responseExplanation" className="font-weight-bold text-cyan">
                                                Açıklama (Opsiyonel)
                                            </label>
                                            <textarea
                                                id="responseExplanation"
                                                className="form-control"
                                                rows="3"
                                                placeholder="İsteğe bağlı açıklama girebilirsiniz..."
                                                value={this.state.responseForm.responseExplanation}
                                                onChange={this.handleResponseChange}
                                                disabled={this.state.responseSending}
                                                maxLength="500"
                                            />
                                            <small className="text-muted">
                                                Maksimum 500 karakter
                                            </small>
                                        </div>

                                        <div className="alert alert-info">
                                            <strong><i className="fa fa-info-circle"></i> Bilgi:</strong><br />
                                            • KABUL: Faturayı onaylıyorsunuz<br />
                                            • RED: Faturayı reddediyorsunuz<br />
                                            • Bu işlem geri alınamaz!
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={this.closeResponseModal}
                                            disabled={this.state.responseSending}>
                                            İptal
                                        </button>

                                        {this.state.responseSending ? (
                                            <button className="btn btn-primary" disabled>
                                                <ReactLoading type="spin" width={'18px'} height={'18px'} color="#ffffff" />
                                                &nbsp;Gönderiliyor...
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={this.sendInvoiceResponse}>
                                                <i className="fa fa-paper-plane"></i> Gönder
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card" style={{ borderRadius: '8px' }}>
                                    <div>
                                        {invoice && (
                                            <div className="body" style={{ padding: '20px' }}>
                                                <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginBottom: '20px' }}>
                                                    <h4 style={{ color: "#333", fontWeight: "600", margin: 0 }}>
                                                        Fatura Kesim Tarihi: <span className="text-cyan">{this.state.invoice.document_issue_date && mainHelper.dateFormat(this.state.invoice.document_issue_date).split(' 03')[0]}</span>
                                                    </h4>
                                                    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                        {invoice.status && invoice.status !== 'BEKLEMEDE' && (
                                                            <span className={`badge ${invoice.status === 'KABUL' ? 'badge-success' : 'badge-danger'}`}
                                                                style={{ fontSize: '13px', padding: '6px 12px' }}>
                                                                <i className={`fa ${invoice.status === 'KABUL' ? 'fa-check' : 'fa-times'}`}></i>
                                                                &nbsp;{invoice.status}
                                                            </span>
                                                        )}
                                                        {invoice.id && invoice.documentId && (
                                                            <button onClick={this.showInvoice}
                                                                className="btn btn-success btn-sm">
                                                                <i className="fa fa-file-pdf-o"></i> PDF Görüntüle
                                                            </button>
                                                        )}
                                                        {invoice.id && (!invoice.status || invoice.status === 'BEKLEMEDE') && invoice.document_profile === "TICARIFATURA" && (
                                                            <button
                                                                onClick={this.openResponseModal}
                                                                className="btn btn-info btn-sm">
                                                                <i className="fa fa-check-square-o"></i> Yanıtla
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="body" style={{ padding: '20px' }}>
                                            {invoice && (
                                                <div className="row">
                                                    {/* Müşteri Bilgileri */}
                                                    <div className="col-lg-6 col-md-12 mb-3">
                                                        <div style={{ padding: '15px', background: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                                                            <div className="d-flex align-items-center mb-3">
                                                                <img
                                                                    alt="User"
                                                                    className="user-photo"
                                                                    style={{ width: '60px', height: '60px', borderRadius: '50%', marginRight: '15px' }}
                                                                    src={`https://ui-avatars.com/api/?name=${(customer?.name + ' ' + (customer?.surname || '')) || (invoice.source_title)}&color=7F9CF5&background=EBF4FF`}
                                                                />
                                                                <div style={{ flex: 1 }}>
                                                                    <h6 className="text-cyan font-weight-bold mb-0">Müşteri Bilgileri</h6>
                                                                </div>
                                                                {invoice.customer_id && (
                                                                    <button onClick={this.openCustomerDetail}
                                                                        className="btn btn-outline-info btn-sm">
                                                                        <i className="fa fa-external-link"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{ fontSize: '12px', fontWeight: '600' }}>Ad Soyad</small>
                                                                    <strong style={{ fontSize: '14px' }}>{(customer?.name || '') + ' ' + (customer?.surname || '') || invoice.source_title || 'Belirtilmemiş'}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{ fontSize: '12px', fontWeight: '600' }}>Vergi/TC No</small>
                                                                    <strong style={{ fontSize: '14px' }}>{customer?.tax_no || invoice.source_id || 'Belirtilmemiş'}</strong>
                                                                </div>
                                                                <div style={{ gridColumn: '1 / -1' }}>
                                                                    <small className="text-muted d-block" style={{ fontSize: '12px', fontWeight: '600' }}>Ünvan</small>
                                                                    <strong style={{ fontSize: '14px' }}>{customer?.title || invoice.source_title || 'Belirtilmemiş'}</strong>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Fatura Bilgileri */}
                                                    <div className="col-lg-6 col-md-12 mb-3">
                                                        <div style={{ padding: '15px', background: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                                                            <h6 className="text-cyan font-weight-bold mb-3">Fatura Bilgileri</h6>
                                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{ fontSize: '12px', fontWeight: '600' }}>Fatura No</small>
                                                                    <strong style={{ fontSize: '14px' }}>{invoice.documentId || '-'}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{ fontSize: '12px', fontWeight: '600' }}>Fatura Tipi</small>
                                                                    <strong style={{ fontSize: '14px' }}>{invoice.document_type || '-'}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{ fontSize: '12px', fontWeight: '600' }}>Tip Kodu</small>
                                                                    <strong style={{ fontSize: '14px' }}>{invoice.document_type_code || '-'}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{ fontSize: '12px', fontWeight: '600' }}>Profil</small>
                                                                    <strong style={{ fontSize: '14px' }}>{invoice.document_profile || '-'}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{ fontSize: '12px', fontWeight: '600' }}>Gelen URN</small>
                                                                    <strong style={{ fontSize: '13px', wordBreak: 'break-all' }}>{invoice.source_urn || '-'}</strong>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block" style={{ fontSize: '12px', fontWeight: '600' }}>Fatura UUID</small>
                                                                    <strong style={{ fontSize: '13px', wordBreak: 'break-all' }}>{invoice.document_uuid || '-'}</strong>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                    <div className="body" style={{ padding: '20px', background: '#f8f9fa' }}>
                                        <h6 className="text-cyan font-weight-bold mb-3">
                                            <i className="fa fa-edit"></i> Cari Bilgileri
                                        </h6>
                                        <div style={{ background: '#fff', padding: '20px', borderRadius: '8px' }}>
                                            <div className="row">
                                                <div className="col-lg-3 col-md-6 mb-3">
                                                    <div className="form-group mb-0">
                                                        <label htmlFor="branch_id" className="font-weight-bold text-cyan" style={{ fontSize: '13px' }}>
                                                            Şube
                                                        </label>
                                                        <select id='branch_id'
                                                            className="form-control"
                                                            value={this.state.formData.branch_id}
                                                            onChange={this.handleInvoiceChange}>
                                                            <option value="">Şube Seçiniz</option>
                                                            {branches && (branches.map(branch => (
                                                                <option key={branch.id} value={branch.id}>{branch.name}</option>
                                                            )))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 mb-3">
                                                    <div className="form-group mb-0">
                                                        <label htmlFor="total_amount" className="font-weight-bold text-cyan" style={{ fontSize: '13px' }}>
                                                            Toplam Tutar
                                                        </label>
                                                        <input name="total_amount"
                                                            id="total_amount"
                                                            className="form-control"
                                                            type="text"
                                                            value={this.state.formData.total_amount}
                                                            onChange={this.handleInvoiceChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 mb-3">
                                                    <div className="form-group mb-0">
                                                        <label htmlFor="vat_amount" className="font-weight-bold text-cyan" style={{ fontSize: '13px' }}>
                                                            KDV Tutarı
                                                        </label>
                                                        <input name="vat_amount"
                                                            id="vat_amount"
                                                            className="form-control"
                                                            type="text"
                                                            value={this.state.formData.vat_amount}
                                                            onChange={this.handleInvoiceChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 mb-3">
                                                    <div className="form-group mb-0">
                                                        <label htmlFor="due_date" className="font-weight-bold text-cyan" style={{ fontSize: '13px' }}>
                                                            Vade Tarihi
                                                        </label>
                                                        <input name="due_date"
                                                            id="due_date"
                                                            className="form-control"
                                                            type="date"
                                                            value={this.state.formData.due_date}
                                                            onChange={this.handleInvoiceChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-6 mb-3">
                                                    <div className="form-group mb-0">
                                                        <label htmlFor="payment_status" className="font-weight-bold text-cyan" style={{ fontSize: '13px' }}>
                                                            Ödeme Durumu
                                                        </label>
                                                        <select name="payment_status"
                                                            id='payment_status'
                                                            className="form-control"
                                                            value={this.state.formData.payment_status}
                                                            onChange={this.handleInvoiceChange}>
                                                            <option value="">Seçiniz</option>
                                                            <option value="paid">Ödendi</option>
                                                            <option value="unpaid">Ödenmedi</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-9 col-md-12 mb-3">
                                                    <div className="form-group mb-0">
                                                        <label htmlFor="description" className="font-weight-bold text-cyan" style={{ fontSize: '13px' }}>
                                                            Cari Detayı
                                                        </label>
                                                        <textarea name="description"
                                                            id="description"
                                                            className="form-control"
                                                            rows="3"
                                                            value={this.state.formData.description}
                                                            onChange={this.handleInvoiceChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-right" style={{ marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #e9ecef' }}>
                                                {this.state.invoice && this.state.invoice.is_receivable_created === 0 && (
                                                    <button
                                                        disabled={!userHasCreateInvoice}
                                                        onClick={this.createReceivable}
                                                        className="btn btn-success">
                                                        <i className="fa fa-plus-circle"></i> Cari Oluştur
                                                    </button>
                                                )}
                                                {loading ? (
                                                    <button className="btn btn-info ml-2" disabled>
                                                        <ReactLoading type="spin" width={'18px'} height={'18px'} color="#ffffff" />
                                                        &nbsp; Kaydediliyor...
                                                    </button>
                                                ) : (
                                                    <button
                                                        disabled={!userHasCreateInvoice}
                                                        onClick={this.handleSubmit}
                                                        className="btn btn-info ml-2">
                                                        <i className="fa fa-save"></i> Cari Oluştur
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );

    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(DocumentDetail)));
